import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from './error.service';

export const HttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const errorService = inject(ErrorService);
    return next(req).pipe(
        catchError(error => {
            const correlationId = req.headers.has('X-Correlation-Id') ? req.headers.get('X-Correlation-Id') : undefined;
            errorService.handleHttpError(req.method, error, correlationId);
            return throwError(() => error);
        }),
    );
};
